import React from "react";

const AboutUs = () => {
  return (
    <>
      <div> about</div>
    </>
  );
};

export default AboutUs;
